import { Component } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
  selector: 'current-mandat',
  templateUrl: './current-mandat.component.html',
  styleUrls: ['./current-mandat.component.css']
})
export class CurrentMandatComponent {

  constructor(public authService: AuthService) { }
}
